
export default "/assets/currency-dollar.59d62604.svg"